<template>
    <v-scale-transition>
      <v-bottom-sheet
        class="rounded-t-xl elevation-0"
        v-model="data.sheet"
        inset
      >
        <template v-slot:activator="{ on, attrs }">
          <v-sheet
            v-bind="attrs"
            v-on="on"
            class="bg_light kc-colleague mx-auto"
          >
            <v-avatar color="primary" size="56" class="mr-2"></v-avatar>
            <div class="kc-content">
              <h6>{{ data.name }}</h6>
              <p class="mb-0">{{ data.function }}</p>
            </div>
          </v-sheet>
        </template>

        <v-sheet
          class="text-center rounded-t-xl elevation-0 pa-3"
          height="400px"
        >
          <div class="text-center m-auto">
            <v-avatar color="primary" size="56" class="mr-2"></v-avatar>
            {{ data.name }} - {{ data.function }}
          </div>
          <VueQRCodeComponent
            :text="`${this.$route.path}`"
            size="150"
            color="#011a62"
            bg-color="#fff"
            error-level="L"
            class="colleague-qr display-flex d-flex justify-center pa-10"
          />

          <v-row>
            <v-col cols="6" sm="6">
              <v-btn elevation="0" block large color="bg_light" class="">
                <v-icon
                  class="mr-2"
                  color="primary"
                  v-text="'fal fa-chevron-right'"
                  to=""
                ></v-icon>

                Profiel</v-btn
              >
            </v-col>
            <v-col cols="6" sm="6">
              <v-btn elevation="0" block large color="secondary">
                <v-icon class="mr-2" v-text="'fal fa-download'"></v-icon>
                Opslaan</v-btn
              >
            </v-col>
          </v-row>
        </v-sheet>
      </v-bottom-sheet>
    </v-scale-transition>
</template>
<script>
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: { VueQRCodeComponent },
  props: {
    data: Object,
  },
};
</script>
<style>
.colleague-qr img {
  margin: auto;
}
.kc-colleague {
  padding: 10px;
  border-radius: 10px !important;
  margin: 10px !important;
  display: flex;
  align-items: center;
}
.kc-content {
  position: relative;
  display: inline-block;
}

.kc-content h6 {
  font-size: 14px;
  font-weight: bold;
}
</style>
